import {observer} from 'mobx-react-lite'
import {useLocation} from 'react-router-dom'
import clubStore from '../../../storage/ClubStore'
import {useEffect} from 'react'
import PageLayout from '../../PageLayout'
import appStore from '../../../storage/AppStore'
import '../Parent/parent.css'
import GamesFilter from "../../Games/GamesFilter";
import NumericPagination from "../../NumericPagination";
import GamesList from "../../Games/GamesList";

const MemberGames = () => {
  const location = useLocation();
  const contest = clubStore.child.contest
  useEffect(() => {
    clubStore.child.getChild().then(() => {
      clubStore.child.contest.searchGames()
    })
  }, [location.pathname])
  
  return (
    <PageLayout header={
      <div className="flex justify-content-between align-items-center">
        <h3 className="m-0">{appStore.tr.games}</h3>
      </div>
    } filters={
      <GamesFilter store={contest}/>
    } pagination={
      <NumericPagination
                    query={contest.gamesQuery}
                    onPageChange={(page) => {
                      contest.gamesQuery.setProperty("page_number", page);
                      contest.searchGames();
                    }}
                  />
    }>
      <GamesList role={'MMBR'} games={contest.games} detailsBasePath={'/member/game'}/>
    </PageLayout>
  )
}

export default observer(MemberGames)